export const cgEnum = {
    CHECKCARD: "1",
    DEBTPAYMENT: "2",   
}